import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

/*
TODO: enable strict
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
*/

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <App />
)
